import { React, useState, useEffect } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import PDFToWordUploadView from "./PDFToWordUploadView";
import { BASE_URL, MAX_UPLOAD_FILE_SIZE } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function PDFToWordMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "PDF To Word Converter Online Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);
  //set progress
  //top loading bar
  const [progress, setProgress] = useState(0);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_to_word", title: "Convert PDF To Word Online" },
    data2: { link: "/pdf_to_word", title: "PDF To DOC, DOCX Online" },
    data3: { link: "/pdf_to_word", title: "PDF To MS Word Converter" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
        setProgress,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar progress={progress} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert PDF to Word online instantly. Turn PDFs into editable DOC or DOCX files quickly with our fast, secure PDF to Word converter."
      ></meta>
      <meta
        name="keywords"
        content="pdf to word, convert pdf to word, pdf to doc, pdf to docx, online pdf to word, pdf word converter, editable word from pdf, pdf to word online, pdf document to word, pdf text to word, pdf conversion tool, free pdf to word, secure pdf to word, pdf editor online, pdf file converter, pdf to microsoft document converter, pdf to ms word, pdf to doc online, pdf to docx online, pdf to doc free, pdf to doc converter free, pdf to docx converter free, pdf converter online, pdf converter online free,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Upload PDF View */}
        {/* Upload View maxFileSize = 9.9mb */}
        {/* Runpod datauri size limit = 9.9mb */}
        {showEditFileScreen ? (
          <PDFToWordUploadView
            maxFileSize={MAX_UPLOAD_FILE_SIZE}
            allowedFileExtensions={["pdf"]}
          />
        ) : (
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
        )}
        {/* Mid Section */}
        <MiscPageMidSection description="Our PDF to Word converter online website is a fast, reliable, and user friendly tool designed to convert PDF documents into fully editable Microsoft Word files. This advanced PDF to Word online converter supports both PDF and DOC/DOCX formats, accurately extracting text, images, tables, and formatting from PDF files while maintaining the original layout. Whether you are a student working on assignments, a professional editing reports, or a business handling contracts and official documents, this convert PDF to Word online tool simplifies document editing and content reuse. With a simple upload and convert process, users can instantly transform PDF files into Word documents directly in their browser, no software installation or technical expertise required. Our PDF to Word converter online produces high quality, editable Word files that are perfect for updating, sharing, printing, or archiving. The platform ensures strong security, with files processed safely and automatically removed after conversion to protect sensitive data. By converting static PDFs into editable Word documents, this tool saves time, enhances productivity, and makes document management easier for both personal and professional use. If you’re searching for a fast, secure, and accurate PDF to Word online converter, this website is the ultimate solution for efficient and seamless document conversion." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Upload",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="PDF To Word Converter"
          why_use={[
            {
              title: "Convert Non Editable PDFs into Editable Word Documents",
              description:
                "This PDF to Word converter online allows users to transform static PDF files into fully editable DOC or DOCX formats, making it easy to update content, correct errors, or reuse information.",
            },

            {
              title: "Save Time on Manual Rewriting",
              description:
                "Using a convert PDF to Word online tool eliminates the need to manually copy text or recreate documents, saving time and reducing errors.",
            },

            {
              title: "Preserve Original Formatting",
              description:
                "Our reliable PDF to Word online converter retains fonts, tables, images, columns, and layout, ensuring your converted Word documents match the original PDF.",
            },

            {
              title: "Improve Workflow and Productivity",
              description:
                "With a fast PDF to Word converter online website, students, professionals, and businesses can edit and reuse documents quickly, improving workflow efficiency.",
            },

            {
              title: "Easy Online Access Without Software Installation",
              description:
                "This browser based PDF to Word online tool works without downloading or installing software, allowing users to convert PDF files anytime from any device.",
            },

            {
              title: "Ideal for Business and Academic Use",
              description:
                "Our PDF to Word online converter is perfect for editing contracts, resumes, reports, assignments, and other professional or academic documents.",
            },

            {
              title: "Simplifies Content Editing and Collaboration",
              description:
                "Converting PDF to Word online allows easy editing, updating, and collaborative work, which is not possible with static PDF files.",
            },

            {
              title: "Supports Complex PDF Documents",
              description:
                "Advanced PDF to Word converter online tools can handle multi page PDFs, tables, and complex layouts, ensuring accurate conversion for professional use.",
            },

            {
              title: "Secure and Reliable Conversion",
              description:
                "Our secure PDF to Word online website ensures files are handled safely, protecting sensitive information during the conversion process.",
            },
          ]}
        />
        {/* FAQ */}
        <MiscFAQ
          faq_list={[
            {
              title: "How do I convert PDF to Word online?",
              description:
                "To convert PDF to Word online, open the PDF to Word tool on ShivaPDF.com, select your PDF file, start the conversion, and download the resulting Word document when processing is complete. Review the document to check its formatting and content.",
            },
            {
              title: "Can I convert PDF to Word for free?",
              description:
                "An online PDF to Word converter can help you turn PDF documents into editable Word files without installing desktop software. Check ShivaPDF's tool page for current free usage availability, file-size limits, and conversion restrictions.",
            },
            {
              title: "What is a PDF to Word converter?",
              description:
                "A PDF to Word converter transforms a PDF document into an editable word-processing file. It helps you reuse text, paragraphs, tables, and other document content in compatible applications such as Microsoft Word.",
            },
            {
              title: "Can I convert PDF to DOCX?",
              description:
                "Yes, a PDF to Word converter that supports DOCX output can transform a PDF into a Microsoft Word-compatible document. Check the available output formats on the tool page before converting your file.",
            },
            {
              title: "What is the difference between PDF and Word documents?",
              description:
                "PDF files are designed to preserve a document's appearance across devices, while Word documents are designed for editing and formatting text. Converting PDF to Word makes it easier to revise content, update paragraphs, and reuse document information.",
            },
            {
              title: "Can I edit a PDF after converting it to Word?",
              description:
                "Yes, the converted Word document can be edited in compatible word-processing software if the converter produces editable content. You can revise text, update paragraphs, adjust formatting, and reuse the document for other purposes.",
            },
            {
              title: "Will PDF to Word conversion preserve the original formatting?",
              description:
                "A PDF to Word converter attempts to preserve text, fonts, spacing, images, and page layout. However, complex tables, columns, headers, footers, and unusual fonts may change during conversion, so review the output document.",
            },
            {
              title: "Can I convert a scanned PDF to Word?",
              description:
                "Scanned PDFs contain images of document pages rather than directly accessible text. Converting them into editable Word documents generally requires optical character recognition (OCR), and the result depends on the OCR engine and scan quality.",
            },
            {
              title: "Do I need OCR to convert PDF to Word?",
              description:
                "OCR is usually needed when a PDF contains scanned pages or images of text. Digitally generated PDFs may allow text extraction without OCR, depending on the document and the conversion tool.",
            },
            {
              title: "Can I convert PDF to Word without losing text?",
              description:
                "Text can usually be extracted from digitally generated PDFs, but conversion results depend on the document structure. Complex layouts, unusual fonts, low-quality scans, and unsupported characters may cause missing or incorrectly positioned text.",
            },
            {
              title: "Can I convert PDF to Word while keeping images?",
              description:
                "Many PDF to Word converters attempt to preserve images during conversion. Image placement, dimensions, resolution, and surrounding text flow may change, so check the resulting document before sharing or printing it.",
            },
            {
              title: "Can I convert a multi-page PDF to Word?",
              description:
                "Yes, a converter that supports multi-page documents can convert a PDF containing multiple pages into a Word document. Check the output to confirm that all pages, paragraphs, and other important content have been included.",
            },
            {
              title: "Can I convert a PDF with tables to Word?",
              description:
                "A PDF to Word converter may recreate tables in the Word document. The accuracy of rows, columns, merged cells, and spacing depends on the original layout and the conversion method. Review important tables after conversion.",
            },
            {
              title: "Can I convert PDF to Word on Mac and Windows?",
              description:
                "A browser-based PDF to Word converter can be used on macOS and Windows through a supported web browser. You generally do not need to install a separate desktop conversion application.",
            },
            {
              title: "Can I convert PDF to Word on an iPhone or Android phone?",
              description:
                "You may be able to convert PDF files to Word using a mobile browser. The experience depends on the website's mobile compatibility, your device's memory, and the size and complexity of the document.",
            },
            {
              title: "Can I convert PDF to Word without installing software?",
              description:
                "Yes, a web-based PDF to Word converter lets you access the conversion process through a browser without installing dedicated desktop software, provided your browser and device are supported.",
            },
            {
              title: "Can I convert PDF to Word offline?",
              description:
                "Offline conversion is possible when the required conversion engine and resources are available locally on your device. Many online PDF to Word services require an internet connection, particularly when documents are processed on a remote server.",
            },
            {
              title: "Is it safe to convert PDF to Word online?",
              description:
                "Document privacy depends on how the conversion service processes and stores files. Before converting confidential documents, review the website's privacy policy and check whether files are uploaded, retained, or processed locally.",
            },
            {
              title: "Can I convert a password-protected PDF to Word?",
              description:
                "A password-protected PDF may need to be unlocked before conversion. Only process documents you are authorized to access, and follow the tool's supported steps for protected files.",
            },
            {
              title: "Why does my Word document look different after conversion?",
              description:
                "PDF and Word use different layout systems, so fonts, margins, line spacing, page breaks, and image positions may change during conversion. Review the resulting document and adjust the formatting where necessary.",
            },
            {
              title: "Can I convert PDF to Word and keep hyperlinks?",
              description:
                "Some converters preserve hyperlinks during conversion, while others may not retain every link or its original formatting. Check the resulting Word document to verify that important links work correctly.",
            },
            {
              title: "Can I convert PDF to Word without changing the original PDF?",
              description:
                "PDF to Word conversion generally creates a separate Word document and leaves the original PDF unchanged. Keep the original file if you need to preserve its original layout or compare the converted content.",
            },
            {
              title: "How do I convert a large PDF to Word?",
              description:
                "Select your PDF in a converter that supports its file size and page count, then start the conversion. Large or image-heavy documents may take longer to process, so check the tool's limits and review the resulting Word document.",
            },
            {
              title: "Why should I use ShivaPDF's PDF to Word converter?",
              description:
                "A PDF to Word converter can help you reuse PDF content for editing, studying, business documents, and everyday writing. Visit ShivaPDF's tool page to check its current conversion features, supported output formats, file limits, and privacy details.",
            },
          ]} />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Recommended Tools */}
        <MiscRecommendedPages />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default PDFToWordMain;
